import type { ValidationOptions } from '../types';

export const defaultValidationOptions: ValidationOptions = {
  validateOnMount: false,
  validateSuccessOnUpdate: false,
  validateOnUpdate: true,
  resetOnUpdate: false,
  debounce: 0,
};
